import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Table } from "../Table";
import GridCard from "../Cards/GridCard";
import Search from "../Search/Search";
import { Button } from "@mui/material";
import DeleteCell from "../Layout/CellScope/DeleteCell/DeleteCell";
import "react-responsive-modal/styles.css";
import "./cellStore.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { Loader } from "../Loaders/loader";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import { GridOn, ViewList } from "@mui/icons-material";
import Filter from "../Filter/Filter";
import { set } from "react-hook-form";

export const CellStore = () => {
  const { role } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const [filterd, setFilter] = useState({});
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [batteryId, setbatteryId] = useState("");
  const [viewMode, setViewMode] = useState("list");

  const toggleViewMode = () => {
    setViewMode((prevMode) => (prevMode === "list" ? "grid" : "list"));
  };

  const handleOpen = () => {
    window.open("/auth/addCell", "_blank");
  };

  const editHandler = useCallback(
    (id) => {
      navigate(`/auth/addCell/${id}`);
    },
    [data],
  );

  const handleShowDetails = (id) => {
    window.open(`/auth/cellStore/${id}`, "_blank");
  };

  const handleShowDetailsRow = (id) => {
    if (role !== "admin") {
      window.open(`/auth/cellStore/${id}`, "_blank");
    }
  };

  const paginationData = useMemo(() => {
    return {
      pageSize: 10,
      totalPages: Math.ceil(data ? data.length / 10 : 1),
      totalData: data ? data.length : 15,
    };
  }, []);

  const removeFromList = (id) => {
    const updatedData = data.filter((cell) => cell._id !== id);
    setData(updatedData);
  };


  useEffect(() => {
    const getBatteryData = async () => {
      const response = await axios.get(`${process.env.BACKEND_URL}batteries`);
      setData(response.data);
      setFilteredData(response.data);
      setFilter({ value: "", label: "All" })
    };
    getBatteryData();
  }, []);

  // useEffect(() => {
  //   if(data && data.length > 0) {
  //     setFilteredData(data);
  //   }
  // }, [filterd]);

  const columnDef = [
    // {
    //   accessorKey: "battery_id",
    //   header: "Battery ID",
    // },
    // {
    //   header: "S.No.",
    //   cell: (data) => {
    //     return data.row.index + 1;
    //   },
    // },
    {
      header: "Image",
      cell: (data) => {
        return (
          <div className="flex gap-1 md:gap-2 align-center justify-center">
            <img
              src={`${process.env.BACKEND_URL}files/${data.row.original.cell_image}?thumb=1`}
              alt="cellImage"
              className="w-5 h-5 md:w-10 md:h-10"
            />
            <img
              src={`${process.env.BACKEND_URL}files/barcode/${data.row.original.battery_id}`}
              alt="barcode"
              className="w-5 h-5 md:w-10 md:h-10"
            />
          </div>
        );
      },
    },
    // {
    //   // accessorKey: `${process.env.BACKEND_URL}files/barcode/${cellData.battery_id}`,
    //   header: "Barcode",
    //   cell: (data) => {
    //     return (
    //       <img
    //         src={`${process.env.BACKEND_URL}files/barcode/${data.row.original.battery_id}`}
    //         alt="barcode"
    //         className="w-10 h-10"
    //       />
    //     );
    //   },
    // },
    {
      accessorKey: "manufacturer",
      header: "Manufacturer",
    },
    {
      accessorKey: "model",
      header: "Model",
    },
    {
      accessorKey: "type",
      header: "Type",
    },
    {
      accessorKey: "capacity",
      header: "Capacity",
    },
    {
      accessorKey: "nominal_voltage",
      header: "Voltage",
    },
    // {
    //   accessorKey: "diameter",
    //   header: "Diameter",
    // },
    // {
    //   accessorKey: "volume",
    //   header: "Volume",
    // },
    {
      accessorKey: "soh",
      header: "SoH",
    },
    {
      accessorKey: "price",
      header: "Price",
    },
    {
      accessorKey: "actions",
      header: "Actions",
      cell: (data) => {
        return (
          <div className="flex gap-2">

            {role === "admin" && (
              <>
                <Visibility
                  cursor="pointer"
                  onClick={() => handleShowDetails(data.row.original._id)}
                >
                  Show Details
                </Visibility>
                <Edit
                  color="info"
                  cursor="pointer"
                  onClick={() => editHandler(data.row.original._id)}
                >
                  Edit
                </Edit>
                <Delete
                  color="error"
                  cursor="pointer"
                  onClick={() => { setbatteryId(data.row.original._id), setOpenDeleteModal(true) }}
                >
                  Delete
                </Delete>
              </>
            )}

          </div>
        );
      },
    },
  ];

  if (!data) {
    return <Loader />;
  }

  const gridDeleteHandler = (id) => {
    setbatteryId(id);
    setOpenDeleteModal(true);
  };

  return (
    <div className="text-white pt-4 flex flex-col gap-10 items-center justify-center">
      <h1 className="text-xl text-[#e8442d] text-center md:text-2xl lg:text-4xl">
        CellScope: Cell Store powered by SoH data
      </h1>

      <div className="flex flex-col gap-7 items-center justify-center w-[85%]">
        <Search searchData={data} />
        <Filter data={data} setFilteredData={setFilteredData} />
        {role === "admin" && (
          <p
            className="text-[#e8442d] text-sm md:text-xl cursor-pointer hover:text-[#e85d01] underline md:underline-offset-8"
            onClick={() => navigate("/auth/cellscope")}
          >
            Visit Cell Scope Inventory
          </p>
        )}
        <div className="w-[100%] flex flex-row justify-between">
          {role === "admin" ? (
            <div className="w-[100%] flex flex-row items-center gap-5 my-0 md:my-1">
              <Button
                variant="contained"
                className="md:w-[20%] w-[80%] text-xs md:text-sm"
                sx={{
                  backgroundColor: "#e8442d",
                  fontFamily: "Bai Jamjuree",
                  "&:hover": {
                    backgroundColor: "#e85d01",
                  },
                  "&:active": {
                    backgroundColor: "#e85d01",
                  },
                }}
                onClick={handleOpen}
              >
                Add Cell
              </Button>
            </div>
          ) : (
            <div className="flex flex-row items-center">
              <p
                className="text-[#e8442d] text-sm md:text-xl cursor-pointer hover:text-[#e85d01] underline md:underline-offset-8"
                onClick={() => navigate("/auth/cellscope")}
              >
                Cell Scope Inventory
              </p>
            </div>
          )}
          <div className="flex items-center border border-gray-300 rounded-[50px] bg-[#f9f9f9] ml-7 h-[max-content]">
            <div className={`hover:bg-[#e8432d51] hover:text-white rounded-l-[50px] cursor-pointer ${viewMode === "grid" ? "bg-[#e8432d7b]" : ""}`}
              onClick={toggleViewMode}
            >
              <GridOn className="cursor-pointer my-1 mx-2 md:my-3 md:mx-4" />
            </div>
            <div className="border-r border-gray-300 h-full"></div>
            <div className={`hover:bg-[#e8432d51] hover:text-white rounded-r-[50px] cursor-pointer ${viewMode === "list" ? "bg-[#e8432d7b]" : ""}`}
              onClick={toggleViewMode}
            >
              <ViewList className="cursor-pointer my-1 mx-2 md:my-3 md:mx-4" />
            </div>
          </div>
        </div>
        <Table
          columns={role === "admin" ? columnDef : columnDef.filter((col) => col.accessorKey !== "actions")}
          currentPage={currentPage}
          data={filteredData}
          loadingData={false}
          onRowClick={handleShowDetailsRow}
          setCurrentPage={setCurrentPage}
          viewHandler={handleShowDetails}
          editHandler={editHandler}
          deleteHandler={gridDeleteHandler}
          viewMode={viewMode}
          isEditable={role === "admin"}
        />
      </div>
      <DeleteCell openDeleteModal={openDeleteModal} onDelete={removeFromList} batteryId={batteryId} setOpenDeleteModal={setOpenDeleteModal} />


      <div className="text-white pt-4 flex flex-col gap-12 items-center justify-center">
        <h1 className="text-xl text-[#e8442d] text-center md:text-2xl lg:text-4xl">
          What is CellScope?
        </h1>
        <p className="text-sm  md:text-lg lg:text-xl w-[85%] text-justify">
          CellScope offers a wide range of services for battery cells.
          Our Cell store contains a large number of fully characterized Cells, and our CellScope
          engine will fetch the most-uniform bunch of cells for your Battery configuration along with
          all the SoH data we have collected for each cell. This will make your life easy by taking
          away the pain of doing laborious cell-matching before connecting them together into your
          pack.
        </p>
        <p className="text-sm  md:text-lg lg:text-xl w-[85%] text-justify">
          We are also proud to offer recycled cells (with fully traceable SoH characterization data)
          through our CellScope powered marketplace at a bargain price. These cells are sourced from
          retired EV batteries and other e-waste and they are thoroughly assessed for their
          state-of-health in our lab. Generally, EV batteries are retired after depletion of around
          25% battery life, and they offer a good value for second-life applications life energy
          storage. Our marketplace aims to establish a circular economy for battery cells in order to
          save our planet.
        </p>
      </div>
    </div>
  );

};